export default __webpack_public_path__ + "static/media/locusofcontrol1Img2.83ad4e2c.png";